import type { RetailhubEventsData } from "../types";

export interface HistoryItem {
  event: string;
  data: any;
}

export type ListenersMap = { [key: string]: any[] };

export function createHistory(
  historyLimit: number,
  listeners: ListenersMap
): Array<HistoryItem> {
  const history = Object.create(Array.prototype, {
    push: {
      value: (item: HistoryItem) => {
        Array.prototype.unshift.call(history, item);
        if (history.length > historyLimit) {
          Array.prototype.pop.call(history);
        }
        if (listeners[item.event] && listeners[item.event].length > 0) {
          listeners[item.event].forEach((callback) => {
            try {
              callback(item.data);
            } catch (error) {
              console.error(
                `Error executing callback for event '${item.event}':`,
                callback,
                error
              );
            }
          });
        }
      },
      enumerable: true,
      writable: true,
      configurable: true,
    },
  }) as Array<HistoryItem>;

  return history;
}
